<template>
  <page-header class="legal-page-header">
    <div class="tag-title">
      <h1 v-if="title">
        {{ title }}
      </h1>
    </div>
  </page-header>
</template>

<script>
import PageHeader from '../../components/PageHeader'

export default {
  name: 'LegalPageHeader',
  components: { PageHeader },
  computed: {
    title () {
      return this.$t(`legal.${this.$route.params.page}`)
    }
  }
}
</script>

<style lang="scss">
  .legal-page-header {
    h1 {
      text-transform: capitalize;
    }
  }
</style>
